var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7357 14.4375C12.3102 14.4375 11.8848 14.2808 11.5489 13.9449L0.487035 2.86063C-0.162345 2.21125 -0.162345 1.13641 0.487035 0.487035C1.13641 -0.162345 2.21125 -0.162345 2.86063 0.487035L13.9225 11.5713C14.5719 12.2207 14.5719 13.2955 13.9225 13.9449C13.5866 14.2808 13.1611 14.4375 12.7357 14.4375Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.67383 14.4366C1.24838 14.4366 0.822921 14.2798 0.487035 13.944C-0.162345 13.2946 -0.162345 12.2197 0.487035 11.5704L11.5489 0.508519C12.1983 -0.14086 13.2731 -0.14086 13.9225 0.508519C14.5719 1.1579 14.5719 2.23273 13.9225 2.88211L2.86063 13.944C2.52474 14.2798 2.09929 14.4366 1.67383 14.4366Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossBtn);
export default __webpack_public_path__ + "static/media/CrossBtn.edc50c28fd18e9e251279ce4860a0798.svg";
export { ForwardRef as ReactComponent };